import { Form, redirect, useLoaderData, type ActionFunction, type LoaderFunction } from "react-router";

import { Api, Types } from "@/services";
import { httpSuccessToast } from "@/utils";
import { JOB_STATUS, JOB_TYPE } from "@/helpers";

import { DashboardFormPageWrapper, FormRow, FormRowSelect, SubmitBtn } from "@/components";

export const editJobLoader: LoaderFunction = async ({ params }) => {
  const { data } = await Api.SingleJob(params.id!);
  return data;
};

export const editJobAction: ActionFunction = async ({ request, params }) => {
  const formData = await request.formData();
  const payload = Object.fromEntries(formData);

  const resp = await Api.EditJob(params.id!, payload);
  httpSuccessToast(resp, "Job edited successfully");
  return redirect("../all-jobs");
};

const EditJob = () => {
  const { job } = useLoaderData<Types.Response.EditJob>();

  return (
    <DashboardFormPageWrapper>
      <Form className="form" method="POST">
        <h4 className="form-title">Edit Job</h4>
        <div className="form-center">
          <FormRow name="position" defaultValue={job.position} />
          <FormRow name="company" defaultValue={job.company} />
          <FormRow labelText="job location" name="jobLocation" defaultValue={job.jobLocation} />
          <FormRowSelect labelText="job status" name="jobStatus" list={Object.values(JOB_STATUS)} defaultValue={job.jobStatus} />
          <FormRowSelect labelText="job type" name="jobType" list={Object.values(JOB_TYPE)} defaultValue={job.jobType} />
          <SubmitBtn formBtn />
        </div>
      </Form>
    </DashboardFormPageWrapper>
  );
};

export default EditJob;
